export default "__VITE_ASSET__DBwb9EE3__"